export default __webpack_public_path__ + "static/media/reply.d9469cb8.png";